import React from 'react';
import './Loading.scss';
import IconProcessing from './IconProcessing';

const Loading = () => (
  <div className="Loading">
    <IconProcessing />
  </div>
);

export default Loading;
